import $ from 'jquery'

export default {
    name: 'assure-chambres',
    components: {},
    props: {
        list_exclu_chambres: Array
    },
    data() {
        return {
            all_checked: false,
            one_is_checked: [],
			each_cat_is_checked: [],
            text_grey: []
        }
    },

    watch: {
        one_is_checked() {
            this.$store.commit('SET_EXCLU_CHAMBRE', this.one_is_checked)
        }
    },

    computed: {
        tarif_chambres() {
            return this.$store.getters["tarif_chambres"];
        },
    },

    mounted() {
        this.listeChambres()
    },

    methods: {
        listeChambres() {
            const data = {
                assurance_id: 0,
                data_type: 'chambre'
            }

            this.$store.dispatch('getTarificationTypeAdmission', data).then(() => {
                if (this.tarif_chambres.length > 0) {
                    this.setSelectedChambres()
                } 
            })
        },

        setSelectedChambres() {
			this.one_is_checked = []
            this.text_grey = []

            this.list_exclu_chambres.forEach(exclusion => {
                this.tarif_chambres.forEach(chambre => {
					if (exclusion.id == chambre.id) {
                        this.text_grey[chambre.id] = 'text-grey'
                        this.one_is_checked.push(chambre.id)
                    } 
                });
            });
		},

        toutSelectionner() {
            let is_checked = $('#all-chambre').is(":checked")
            this.toggleAllChecked(is_checked)
        },

        toggleAllChecked(is_checked) {
            this.one_is_checked = []
            this.each_cat_is_checked = []
            
            this.tarif_chambres.forEach((chambre) => {
                if (is_checked) {
                    this.one_is_checked.push(chambre.id)
                }
                this.text_grey[chambre.id] = (is_checked)?'text-grey':''
            });
            
            this.all_checked = is_checked
        },

        onExclu(index) {
            let is_checked = $('#chambre'+index).is(":checked")

            let c = ''
            if (is_checked == true) {
                c = 'text-grey'
            }
            this.text_grey[index] = c
        },
    }
}